<mat-dialog-title><b>Nevi Değiştirme</b></mat-dialog-title>
<br />

<div>
  <ejs-dropdownlist
    style="color: white; width: 75%; margin-top: 10; margin-bottom: 10"
    id="ddlelement"
    floatLabelType="Auto"
    #customerDDL
    [dataSource]="customerListData"
    placeholder="{{ 'SHARED.SELECTED_COMPANY' | translate }}"
    [fields]="fields"
    [allowFiltering]="true"
    (change)="customerChange($event)"
    [value]="selectedCustomer"
    (filtering)="onFiltering($event)"
    [filterBarPlaceholder]="customerListfilterPlaceholder"
    popupHeight="200px"
    popupWidth="550px"
  >
    <ng-template #noRecordsTemplate>
      <span class="norecord">Kayıt Bulunamadı</span>
    </ng-template>
  </ejs-dropdownlist>
</div>
<mat-dialog-actions align="end" style="padding: 0">
  <button mat-raised-button (click)="changeClick()" color="primary">
    Kaydet
  </button>
  <button mat-raised-button matDialogClose color="primary">Kapat</button>
</mat-dialog-actions>

<div id="ej2Toast" #toast></div>
